import {
  GET_STATES,
  GET_STATE,
  STATE_ERROR,
  SET_CURRENT,
  SET_LOADING,
  CLEAR_CURRENT,
  CLEAR_ERRORS,
} from '../../types'

const initialState = {
  loading: false,
  states: [],
  error: null,
  current: null,
}

type Action = {
  type: string
  payload: {
    states: object
    current: object
  }
}

export const allStates = (state = initialState, { type, payload }: Action) => {
  switch (type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    case GET_STATES:
      return {
        ...state,
        states: payload,
        loading: false,
      }

    case SET_CURRENT:
    case GET_STATE:
      return {
        ...state,
        current: payload,
        loading: false,
      }

    case CLEAR_CURRENT:
      return {
        ...state,
        current: null,
      }

    case STATE_ERROR:
      return {
        ...state,
        error: payload,
      }

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        loading: false,
      }

    default:
      return state
  }
}
